<template>
  <b-card style="min-height: 80vh" class="logo-card">
<!--    <div class="bg-logo"></div>-->
    <h1 class="text-primary welcome-text">به پنل ادمین لنزآوا خوش آمدید.</h1>
  </b-card>
</template>

<script>
import {BRow, BCol, BCard } from 'bootstrap-vue'

export default {
  title: " پنل ادمین لنزآوا",
  components: {
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {

    }
  },
}
</script>

<style lang="scss">
.logo-card {
  display: flex;
  flex-flow: column;
  justify-items: center;
  justify-content: center;
  align-items: center;

}

.bg-logo {
  margin-left: auto;
  margin-right: auto;
  width: 10rem;
  height: 10rem;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-image: url("../../../../src/assets/images/logo/logo-jadid.png");
}

.welcome-text {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-weight: 900;
}

@media only screen and (max-width: 576px) {
  * {
    font-size: 1rem !important;
  }
  .bg-logo {
    width: 20rem;
    height: 20rem;
  }
}

@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
